export const FILTER_QUERY_KEYS = [
    'yearMin', 'yearMax', 'avgRateMin', 'avgRateMax', 'totalGradesMin',
    'totalGradesMax', 'limit', 'orderBy', 'genresMetaInclude', 'genresInclude',
    // Previously published links used API names and comma-separated genres.
    'year_min', 'year_max', 'total_grades_min', 'total_grades_max', 'genreMetaInclude'
];

export function defaultFilters(authorId) {
    const currentYear = new Date().getFullYear();
    return {
        limit: 60,
        yearMin: authorId ? 1 : currentYear,
        yearMax: currentYear,
        avgRateMin: authorId ? 1 : 7,
        avgRateMax: 10,
        totalGradesMin: authorId ? 1 : 5,
        totalGradesMax: 999999,
        orderBy: 'time_desc',
        genresMetaInclude: '',
        genresInclude: '',
        showOnlySubscribedAuthorsBooks: false,
        showOnlyBooksWithoutUserGrades: false
    };
}

export function initialFilters(search, savedFilters = {}, authorId) {
    const params = new URLSearchParams(search);
    const hasQuery = FILTER_QUERY_KEYS.some(key => params.has(key));
    // A shared selection must not inherit another reader's saved restrictions.
    const filters = {...defaultFilters(authorId), ...(!hasQuery && !authorId ? savedFilters : {})};
    const aliases = {
        yearMin: 'year_min', yearMax: 'year_max',
        totalGradesMin: 'total_grades_min', totalGradesMax: 'total_grades_max',
        genresMetaInclude: 'genreMetaInclude'
    };
    for (const key of Object.keys(defaultFilters(authorId)).filter(key => FILTER_QUERY_KEYS.includes(key))) {
        const value = params.get(key) ?? (aliases[key] ? params.get(aliases[key]) : null);
        if (value !== null) filters[key] = value;
    }
    if (params.has('genreMetaInclude') && !params.has('genresMetaInclude')) {
        filters.genresMetaInclude = filters.genresMetaInclude.split(',').join('|');
    }
    // Old AboutUs links expressed ratings on the API's five-point scale.
    if (params.has('year_min') && !params.has('yearMin')) {
        for (const key of ['avgRateMin', 'avgRateMax']) {
            if (params.has(key)) filters[key] = Number(params.get(key)) * 2;
        }
    }
    return filters;
}

const curatedGenres = 'Детективы и Триллеры|Любовные романы|Приключения|Проза|Фантастика';
export function curatedLink({yearMin, yearMax, totalGradesMin, orderBy}) {
    return '/?' + new URLSearchParams({
        limit: 60, yearMin, yearMax, avgRateMin: 7, avgRateMax: 10,
        totalGradesMin, totalGradesMax: 999999, orderBy,
        genresMetaInclude: curatedGenres
    }).toString();
}
